import { ChangeDetectorRef, Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'gnx-icon-details-dialog',
  templateUrl: './icon-details-dialog.component.html',
  styleUrls: ['./icon-details-dialog.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class IconDetailsDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<IconDetailsDialogComponent>>(MatDialogRef);
  data = inject<{
    path: string;
  }>(MAT_DIALOG_DATA);
  private ref = inject(ChangeDetectorRef);

  bgc = 'white';
  state = 'untouched';

  ngOnInit(): void {}

  public onClose() {
    this.dialogRef.close();
  }

  public changeColor(color: string) {
    this.bgc = color;
  }

  public copyToClipboard() {
    const el = document.createElement('textarea');
    el.value = this.data.path;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.state = 'success';
    setTimeout(() => {
      this.state = 'untouched';
      this.ref.markForCheck();
    }, 2000);
  }
}
